module.exports = __webpack_public_path__ + "static/img/img_0346.c8f92b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0346.jpg
// module id = +K/O
// module chunks = 0